export const TAX_MECHANISM = {
  standard: "standard",
  reverseCharge: "reverseCharge",
} as const;

export type TaxMechanism = (typeof TAX_MECHANISM)[keyof typeof TAX_MECHANISM];

export const TAX_RATES = Object.freeze({
  DE: [
    { value: 7.8, mechanism: TAX_MECHANISM.standard },
    { value: 19, mechanism: TAX_MECHANISM.standard },
  ],
  PL: [{ value: 0, mechanism: TAX_MECHANISM.reverseCharge }],
});
